import { serverUrl, setErrorDialog } from '../store/api/CommonFunctions';
import React, { useState, useEffect, Fragment } from 'react';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getfirebaseToken } from './../firebase';
import { useHistory } from 'react-router-dom';
import { Col, FormGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDoorOpen } from '@fortawesome/free-solid-svg-icons';
const LoginCustomer = (props) => {
  useEffect(() => {
    document.body.classList = "notMain";
  }, []);
  const history = useHistory();
  const [placeHolder, setPlaceHolder] = useState("کد ملی خود را وارد کنید");
  const [loginError, setLoginError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const company = JSON.parse(localStorage.getItem("Company"));

  function getResult(url, data) {
    setLoginError(null);
    const resp = fetch(url, {
      method: 'get',
      redirect: 'follow'
    }).then(res => res.json())
      .then(resp => {
        setLoading(false);
        if (resp.Message === "NotExists") {
          setLoginError("کاربری با این مشخصات در سیستم وجود ندارد");
          return;
        }
        if (resp.Message === "IsBlackList") {
          setLoginError("کاربر در لیست سیاه قرار گرفته و امکان دریافت خدمات را ندارد");
          return;
        }
        if (resp.Message === "IsNotActive") {
          setLoginError("کاربر فعال نیست");
          return;
        }
        if (resp.Message?.toLowerCase() === "error") {
          setLoginError("ورود به سیستم با مشکل مواجه شد");
          return;
        }
        else if(resp.Message)
        {
          setLoginError(resp.Message);
          return;
        }
        localStorage.setItem('token', resp);
        getfirebaseToken(serverUrl);
        props.setUser(resp);
      }).catch(err => {
        console.log(err);
      });
  }


  function onSubmit(data) {

    const { setUser } = props;

    const userUrl = serverUrl + `api/CustomersApi/LoginCustomer?loginWithMobile=${data.LoginWithMobile}&nationalCodeOrMobile=${data.UserName}&password=${data.Password}`;
    setLoading(true);
    getResult(userUrl, { username: data.UserName, Password: data.Password });

  }
  function setMobileLogin(value) {
    if (value) {
      setPlaceHolder("شماره همراه خود را وارد کنید");
    }
    else {
      setPlaceHolder("کد ملی خود را وارد کنید");
    }
  }
  const { register, handleSubmit, errors } = useForm();
  return (
    <Fragment>
      <div className='logingPageLogoContainer'>
        <img src={company?.CompanyLogo} className='loginPageLogo' />
      </div>
      <div className="container justify-content-center d-flex loginContainer">
        <div className="card flex-grow-1">
          <div className="card-header headerStyle loginHeader">
            <h2> ورود به سامانه </h2>
          </div>
          <div className="card-body bodyStyle d-flex">
            <div style={{ flexGrow: 2 }} className='loginInfo'>
              <div className='loginTitle'>
                <span></span>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <FormGroup>
                  <input type='checkbox' className='form-check-input' name="LoginWithMobile" ref={register({})} onChange={e => setMobileLogin(e.target.checked)} />
                  &nbsp;
                  <label style={{color:"blue", fontWeight:"bold"}}>ورود با شماره همراه</label>
                  &nbsp;
                </FormGroup>
                <div className="form-group">
                  <label> نام کاربری </label>
                  <input className="form-control" name="UserName" placeholder={placeHolder} ref={register({ required: true })} type="text" />
                  {errors.UserName && <small className="errors"> نام کاربری اجباری است </small>}
                </div>
                <br />
                <div className="form-group mt-0">
                  <label> رمز عبور </label>
                  <input className="form-control" name="Password" ref={register({ required: true })} type="password" />
                  {errors.Password && <small className="errors"> رمز عبور را وارد کنید</small>}
                </div>

                <div className="form-group">
                  {loginError && <div className="errors mb-2">{loginError}</div>}
                  <button className="btn btn-block btn-primary w-100"> {isLoading && "لطفا کمی صبر کنید"}  {!isLoading && "ورود"} </button>

                </div>
              </form>
              <div className="row" style={{fontSize:"13px"}}>
                <Col md={4} style={{padding:0}}>
                  <button className="btn btn-block" style={{ color: 'red' }} onClick={() => { props.setRegister(true); history.push("/RegisterCustomer") }}>ثبت نام </button>
                </Col>
                <Col md={4} style={{padding:0}}>
                  <button className="btn btn-block" style={{ color: 'red' }} onClick={() => { props.setForgetPassword(true); history.push("/ForgetPassword") }}>بازیابی رمز عبور</button>
                </Col>
                <Col md={4} style={{padding:0}}>
                  <button className="btn btn-block" style={{ color: 'red' }} onClick={() => { props.setService(true); history.push("/ServiceWithoutLogin") }}>درخواست سریع</button>
                </Col>                
              </div>
            </div>
            {window.innerWidth > 414 &&
              <div style={{ flexGrow: 3 }} className='loginImageContainer'>
                <img src={process.env.PUBLIC_URL + "/images/LoginImage.png"} className='loginImage' />
              </div>
            }
          </div>
        </div>
      </div>
    </Fragment >)
}

export default LoginCustomer;